'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import Button from '../../Button/index.js';
import Dialog from '../../Dialog/index.js';
import { IconUploadButton } from '../../UploadResumeModal/images.js';
import { isMobile } from '../../Utils/helpers.js';
import { FILE_UPLOAD_SIZE } from '../constants.js';
import { IconCloudUpload, IconChecked } from '../images.js';
import translations from '../translations.js';
import { Container, UploadText, DropFileLabel, UploadDropFile, DropFileIcon, DropFileBigText, DropFileText, DropFileButton, DropFileDiv, DropFileInput, DropFileMdText, LoadingBarWrapper, LoadingBarContainer, LoadingBarLeft, LoadingBarName, LoadingBar, BarProgress, LoadingBarProgress, UploadSuccess, UploadSuccessText, SuccessLink } from './styles.js';

function UploadDialog(props) {
    var _a = useState(), file = _a[0], setFile = _a[1];
    var _b = useState(false), loadingCV = _b[0], setLoadingCV = _b[1];
    var _c = useState(false), loadingSuccess = _c[0], setLoadingSuccess = _c[1];
    var _d = useState(0), progress = _d[0], setProgress = _d[1];
    var _e = useState(''), warning = _e[0], setWarning = _e[1];
    var _f = useState(false), isDragOver = _f[0], setDragOver = _f[1];
    var loadingInterval = useRef(null);
    var _g = __assign({}, props), type = _g.type, isOpen = _g.isOpen, onToggleOpen = _g.onToggleOpen, isLoading = _g.isLoading, onChangeLoading = _g.onChangeLoading, onCvUploadLoading = _g.onCvUploadLoading, onCvUpload = _g.onCvUpload, onChangeError = _g.onChangeError, onReloadPage = _g.onReloadPage, onMyProfileClick = _g.onMyProfileClick, onCloseDialog = _g.onCloseDialog, _h = _g.lang, lang = _h === void 0 ? 'vi' : _h, error = _g.error, showErrorMess = _g.showErrorMess, isSuccess = _g.isSuccess, baseUrl = _g.baseUrl;
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var handleOnToggleOpen = function (isOpen) {
        onToggleOpen && onToggleOpen(isOpen);
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setDragOver(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setDragOver(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDragEnd = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setDragOver(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            setFile(e.dataTransfer.files[0]);
        }
    };
    var handleCloseDialog = function () {
        // Choose file
        if (!loadingCV && !loadingSuccess) {
            onChangeError && onChangeError(false);
        }
        // Upload success dashboard
        if (loadingSuccess && type === 'dashboard') {
            onCloseDialog && onCloseDialog();
        }
        handleOnToggleOpen('');
        // Upload success myprofile
        if (loadingSuccess && type === 'myprofile') {
            onCloseDialog && onCloseDialog();
            location.reload();
        }
    };
    var handleNameButton = function () {
        if (loadingSuccess && type === 'myprofile') {
            return t('Review profile');
        }
        else {
            return t('Close');
        }
    };
    var countUpNumber = function (count) {
        if (count === void 0) { count = 0; }
        loadingInterval.current = setInterval(function () {
            if (count < 99) {
                count++;
                setProgress(count);
            }
        }, 600);
    };
    useEffect(function () {
        if (error && loadingInterval.current) {
            setLoadingCV(false);
            clearInterval(loadingInterval.current);
            setWarning('');
            setProgress(0);
        }
    }, [error]);
    useEffect(function () {
        if (isSuccess && loadingInterval.current && onCvUpload && file && onReloadPage) {
            clearInterval(loadingInterval.current);
            onCvUpload(file.name);
            setProgress(100);
            setTimeout(function () { return setLoadingSuccess(true); }, 1500);
        }
    }, [isSuccess]);
    useEffect(function () {
        if (file && onCvUploadLoading && onChangeError && onReloadPage) {
            onChangeError(false);
            if (file.size < FILE_UPLOAD_SIZE) {
                setLoadingCV(true);
                setWarning(t('File uploading'));
                countUpNumber();
                onCvUploadLoading(file);
                onReloadPage(true);
            }
            else {
                setWarning(t('You can attach .pdf file that is less than 5120 KB in size.'));
            }
        }
    }, [file]);
    useEffect(function () {
        if (progress && progress < 100)
            onChangeLoading && onChangeLoading(true);
        else
            onChangeLoading && onChangeLoading(false);
    }, [progress]);
    return (React__default.createElement(Dialog, { title: t('Import from LinkedIn'), isOpen: isOpen, onBack: handleCloseDialog, fullScreenOnMobile: true, actionText: handleNameButton(), primaryButtonType: 'default', onClickAction: handleCloseDialog, backdrop: true, modalContainerStyle: { maxWidth: '550px', width: '100%' }, sizeButton: 'md-h', gridButton: isMobile() ? '1fr' : '1fr 1fr' },
        !loadingCV && !loadingSuccess && (
        // Choose file to upload CV
        React__default.createElement(Container, null,
            React__default.createElement(UploadText, null, t('Now upload your LinkedIn profile')),
            React__default.createElement(DropFileLabel, { htmlFor: 'dropFile', onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDragEnd: handleOnDragEnd, onDrop: handleOnDrop },
                React__default.createElement(UploadDropFile, { isDragOver: isDragOver },
                    React__default.createElement("div", { style: { pointerEvents: 'none' } },
                        React__default.createElement(DropFileIcon, null,
                            React__default.createElement(IconUploadButton, null)),
                        !isMobile() && React__default.createElement(DropFileBigText, null, t('Drag your file here')),
                        !isMobile() && React__default.createElement(DropFileText, null, t('Or you can')),
                        React__default.createElement(DropFileButton, null,
                            React__default.createElement(DropFileDiv, null,
                                React__default.createElement(Button, { style: { cursor: 'no-drop' }, className: 'pointer-disabled', type: 'primary', disabled: isLoading }, t('Choose file to upload')))),
                        React__default.createElement(DropFileInput, { type: 'file', id: 'dropFile', accept: 'application/pdf', onChange: function (e) {
                                var _a, _b;
                                if (!((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.files)) {
                                    return;
                                }
                                setFile((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.files[0]);
                            }, disabled: isLoading }),
                        React__default.createElement(DropFileText, null, t('.pdf files that are less than 5120KB in size')),
                        error && showErrorMess && (React__default.createElement(DropFileText, { style: { color: 'red' } }, error)),
                        warning && React__default.createElement(DropFileText, { style: { color: 'red' } }, warning)))))),
        loadingCV && !loadingSuccess && (
        // Loading CV
        React__default.createElement(Container, null,
            React__default.createElement(UploadText, null, t('Now upload your LinkedIn profile')),
            React__default.createElement(UploadDropFile, null,
                React__default.createElement(DropFileIcon, null,
                    React__default.createElement(IconCloudUpload, null)),
                React__default.createElement(DropFileMdText, null,
                    t('File uploading'),
                    " ..."),
                React__default.createElement(LoadingBarWrapper, null,
                    React__default.createElement(LoadingBarContainer, null,
                        React__default.createElement(LoadingBarLeft, null,
                            React__default.createElement(LoadingBarName, null, file === null || file === void 0 ? void 0 : file.name),
                            React__default.createElement(LoadingBar, null,
                                React__default.createElement(BarProgress, { progress: progress })),
                            React__default.createElement(LoadingBarProgress, null,
                                progress,
                                "%"))))))),
        loadingSuccess && (
        // loading CV successs
        React__default.createElement(Container, null,
            React__default.createElement(UploadText, null, t('Now upload your LinkedIn profile')),
            React__default.createElement(UploadDropFile, null,
                React__default.createElement(DropFileIcon, null,
                    React__default.createElement(IconChecked, null)),
                React__default.createElement(DropFileMdText, { style: { color: '#00b70b' } }, t('Profile upload successful')),
                React__default.createElement(UploadSuccess, null, type === 'dashboard' ? (React__default.createElement(UploadSuccessText, null,
                    t('Your LinkedIn profile has been updated to VietnamWorks’s profile successfully.'),
                    ' ',
                    t('Go to'),
                    ' ',
                    React__default.createElement("a", { href: "".concat(baseUrl, "\\").concat(t('my-profile')), onClick: function () { return onMyProfileClick(); }, rel: 'noreferrer' },
                        React__default.createElement(SuccessLink, null, t('My Profile')),
                        ' '),
                    t('to review your updated profile.'))) : (React__default.createElement(UploadSuccessText, null, t("Your LinkedIn profile has been updated to VietnamWorks's profile successfully.")))))))));
}

export { UploadDialog as default };
//# sourceMappingURL=index.js.map
